<template>
  <div>
    <div class="row row-0">
      <div class="col-sm-6">
        <a
          href="https://www.tout-schuss-premium-credit-agricole.fr/assurance-ski-ca-outrun-def-gh173o6ves/0/9Dokq/"
          data-trackingclass="landing-page-clic-bouton"
          data-trackinginfo="landing-page-CAPS-toutschuss-jouer"
        >
          <img src="../assets/images/pic2.jpg" class="img-fluid" alt="" />
        </a>
      </div>
      <div class="col-sm-6">
        <div id="winter-2-right-column">
          <div>
            Tout savoir sur les garanties Neige et Montagne.
          </div>

          <div
            v-if="thumbnail"
            class="thumbnail-play"
            data-trackingclass="landing-page-clic-bouton"
            data-trackinginfo="landing-page-CAPS-toutschuss-video"
            @click.prevent="thumbnail = false"
          >
            <img
              src="../assets/images/play.png"
              data-trackingclass="landing-page-clic-bouton"
              data-trackinginfo="landing-page-CAPS-toutschuss-video"
              @click.prevent="thumbnail = false"
            />
          </div>

          <iframe
            v-else
            width="560"
            height="315"
            src="https://www.youtube.com/embed/716O1RGgDOI?autoplay=1"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      thumbnail: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .thumbnail-play {
    background: url(../assets/images/video.jpg) no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;

    img {
      position: absolute;
      top: calc(50% - 50px);
      left: calc(50% - 50px);
      width: 100px;
      z-index: 5;
    }
  }

  iframe {
    width: 100% !important;
    height: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Video.vue